import {
  type RouteObject,
} from "react-router";
import StatusDetailApp from "Status/Detail/app";
import ListStatusApp from "Status/List/app";
import StatusNewApp from "Status/New/app";

declare let viewModel: any;

export const statusRoute: RouteObject = {
  path: "status",
  children: [{
    path : ":mainArea",
    loader: () => viewModel,
    Component: ListStatusApp,
  }, {
    path: "detail/:key",
    loader: () => viewModel,
    Component: StatusDetailApp,
  }, {
    path: ":mainArea/new",
    loader: () => viewModel,
    Component: StatusNewApp,
  }]
};